import React from "react";

import { CircularProgress } from "@material-ui/core";

import { CenteredGreedy, FullscreenContainer } from "components/Layout";

function LoadingSpinner({ size, actionName = "Loading", subjectName }) {
  return [
    <CircularProgress size={size} key={0} />,
    `\u00A0${actionName}`,
    subjectName ? ` ${subjectName}` : "",
    "...",
  ];
}

export function FullScreenLoadingSpinner({ actionName, subjectName }) {
  return (
    <FullscreenContainer>
      <CenteredGreedy>
        <LoadingSpinner actionName={actionName} subjectName={subjectName} />
      </CenteredGreedy>
    </FullscreenContainer>
  );
}

export default React.memo(LoadingSpinner);
